import colors from "#tailwind-config/theme/colors"
import {calcAPCA} from "apca-w3"

export const useContrastValidator = (bgColor: string | null = null, isReverse?: boolean): string => {

  const defaultTextColor = colors.neutral["900"]
  const reverseColor = '#ffffff'

  if (!bgColor) return defaultTextColor

  const lightText = calcAPCA(reverseColor, bgColor)
  const darkText = calcAPCA(defaultTextColor, bgColor)

  const contrastLight = typeof lightText === 'string' ? Math.abs(parseFloat(lightText)) : Math.abs(lightText)
  const contrastDark = typeof darkText === 'string' ? Math.abs(parseFloat(darkText)) : Math.abs(darkText)

  const result = contrastDark > contrastLight ? defaultTextColor : reverseColor
  if(isReverse && result === reverseColor) return defaultTextColor;

  return result;
}
